module.exports = __webpack_public_path__ + "images/shopping.08ccfdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/home/shopping.png
// module id = /U1W
// module chunks = 19